'use client';

import { useEffect, useRef } from 'react';

import { getENV, useEffectOnce, useLoyaltyContext, usePageLayout, useStore } from '@libs/common-next';

import { gtmConfig } from '../../constants/config';
import { trackUserAuthentication } from '../../gtm';
import { PageViewTracking } from '../PageViewTracking';

export function NoScriptIframe() {
    const { gtmAuth, gtmPreview, gtmContainerId } = gtmConfig[getENV('NEXT_PUBLIC_LOCALE') == 'en-CA' ? 'ca' : 'us'];

    return (
        <noscript>
            <iframe
                title="gtm-noscript"
                src={`https://www.googletagmanager.com/ns.html?id=${gtmContainerId}&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x`}
                height="0"
                width="0"
                style={{ display: 'none', visibility: 'hidden' }}
            />
        </noscript>
    );
}

export function GtmPageViewTracker() {
    const { isAuthenticated, user, userData } = usePageLayout();
    const { memberPoints } = useLoyaltyContext();
    const shouldTriggerUserAuthenticationEventRef = useRef(true);
    const { selectedStoreId } = useStore();

    // Track user authentication for velocity login (page load).
    // Wait for both memberPoints and userData.profile to be available before firing,
    // so storeId is not sent as null due to a race between loyalty and profile API responses.
    useEffect(() => {
        if (
            isAuthenticated === 'velocity' &&
            memberPoints &&
            userData?.profile &&
            shouldTriggerUserAuthenticationEventRef.current
        ) {
            trackUserAuthentication({
                loyaltyId: user?.loyaltyid?.toString() ?? '',
                storeId: selectedStoreId ?? userData.profile.storeNumber ?? null,
                totalTreatsPoints: memberPoints?.availablePoints ?? 0,
                loginState: true,
            });
            shouldTriggerUserAuthenticationEventRef.current = false;
        }
    }, [isAuthenticated, memberPoints, user, userData, selectedStoreId]);

    useEffect(() => {
        if (!isAuthenticated) {
            shouldTriggerUserAuthenticationEventRef.current = true;
        }
    }, [isAuthenticated]);

    useEffectOnce(() => {
        window.flags = {
            ...window.flags,
            IS_PERFORMANCE_MODE: process.env.NEXT_PUBLIC_PERFORMANCE_MODE === 'true',
        };
    });

    return (
        <>
            <NoScriptIframe />
            <PageViewTracking />
        </>
    );
}
